import React, { memo, useCallback, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useHistory } from 'react-router-dom';
import 'swiper/css/swiper.css';
import styles from './AIGCOpt.module.less';

import { logging } from '../../../../actions/log';
import { CONTEXT } from '../../../../config';
import { aigcClearList, aigcReplyIsBusing, aigcGetReplys } from '../../../../actions/aigc';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectAIGC = createSelector(
  state => state.aigc,
  aigc => aigc,
);

export default memo(({ inputValue }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const AIGCObj = useSelector(selectAIGC); //
  const [isShowClear, setIsShowClear] = useState(false);
  const { aigcUserText, aigcReplys } = useSelector(selectAIGC); // AI当前回答

  const handleClearSure = useCallback(() => {
    dispatch(aigcClearList());
    setIsShowClear(!isShowClear);
    // 打桩
    dispatch(
      logging({
        category: 'C',
        action: 'Search_Aigc_Delete',
        label: '',
        param2: {
          source: `AIGC_${logInfoData.source}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  }, [isShowClear]);

  const handleClearCancel = useCallback(() => {
    setIsShowClear(false);
  }, []);

  const handleShowClear = useCallback(() => {
    setIsShowClear(!isShowClear);
  }, [isShowClear]);

  const handleWritingStop = useCallback(() => {
    // 0: 正常状态,  1: 请求数据中  2: 请求完成  3: 打字中  4; 打字暂停   5: 打字完成
    if ([1, 2, 3].includes(AIGCObj?.isBusing) > -1) {
      dispatch(aigcReplyIsBusing({ isBusing: 4 }));
      let param3 = '';
      try {
        if (
          aigcUserText?.userText === aigcReplys?.userQuestion?.userText &&
          aigcReplys?.replys?.length > 0
        ) {
          let replyLast = aigcReplys.replys[aigcReplys.replys.length - 1];
          param3 = replyLast.bizInfo;
        }
      } catch (error) {}
      // 打桩
      dispatch(
        logging({
          category: 'C',
          action: 'Search_Aigc_Stop',
          label: '',
          param2: {
            source: `AIGC_${logInfoData.source}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            search_word: AIGCObj?.aigcUserText?.userText || '',
            isResult: aigcUserText?.userText === aigcReplys?.userQuestion?.userText ? 1 : 0,
          },
          param3,
        }),
      );
    }
  }, [AIGCObj, aigcUserText, aigcReplys]);

  const handleCheckQuestion = useCallback(question => {
    dispatch(aigcReplyIsBusing({ isBusing: 1 }));
    dispatch(aigcGetReplys({ userText: question }));
    // 打桩
    dispatch(
      logging({
        category: 'C',
        action: 'Search_Aigc_Input',
        label: '',
        param2: {
          source: `AIGC_${logInfoData.source}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          search_word: question,
          type: 2,
        },
      }),
    );
  }, []);

  if ([0, 4, 5].indexOf(AIGCObj.isBusing) === -1) {
    return (
      <div className={styles.aigc_opt_writing}>
        <div className={`aigc_opt_btn`}>
          <div className={`aigc_opt_btn_icon iconfont icon-ai_tingzhihuida`}></div>
          <div className={`aigc_opt_btn_text`} onClick={handleWritingStop}>
            停止回答
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.aigc_opt}>
      <>
        {AIGCObj?.aigcReplyList?.length > 0 && (
          <>
            <div className={isShowClear ? `aigc_clear aigc_clear_` : `aigc_clear`}>
              {isShowClear && (
                <div className={`aigc_clear_box_`}>
                  <div className={`aigc_clear_box`}>
                    <div className={`aigc_clear_box_text`}>是否清除对话？</div>
                    <div className={`aigc_clear_box_cancel`} onClick={handleClearCancel}>
                      取消
                    </div>
                    <div className={`aigc_clear_box_srue`} onClick={handleClearSure}>
                      确认
                    </div>
                  </div>
                </div>
              )}

              <div className={`aigc_clear_icon iconfont icon-ai_qingchu`}></div>
              <div className={`aigc_clear_text`} onClick={handleShowClear}>
                清除对话
              </div>
            </div>

            <div className={`aigc_question`}>
              {AIGCObj?.aigcRecoQuestion?.length > 0 && (
                <>
                  {AIGCObj.aigcRecoQuestion.slice(0, 2).map((item, i) => {
                    return (
                      <div
                        className={`aigc_question_line`}
                        onClick={() => {
                          handleCheckQuestion(item);
                        }}
                        key={i}
                        title={item}
                      >
                        {item}
                      </div>
                    );
                  })}
                </>
              )}
            </div>
          </>
        )}
      </>
    </div>
  );
});
